"use strict";

exports.Logger = void 0;
var LogLevel = /*#__PURE__*/function (LogLevel) {
  LogLevel["DEBUG"] = "debug";
  LogLevel["INFO"] = "info";
  LogLevel["WARN"] = "warn";
  LogLevel["ERROR"] = "error";
  return LogLevel;
}(LogLevel || {});
class Logger {
  /**
   * The name of the logger instance.
   */

  /**
   * A flag that indicates whether the logger is in debug mode.
   */

  /**
   * Creates a new instance of the logger.
   * @param {string} name - The name of the logger instance.
   * @param {boolean} [debugMode=false] - A flag that indicates whether the logger is in debug mode.
   */
  constructor(name, debugMode) {
    this.name = name;
    this.debugMode = debugMode !== null && debugMode !== void 0 ? debugMode : false;
  }

  /**
   * Logs a message at the specified log level.
   * @param {LogLevel} level - The log level to use.
   * @param {string} message - The message to log.
   * @param  {...any[]} args - Additional arguments to log.
   */
  log(level, message) {
    const currentTime = new Date().toISOString();
    if (typeof console !== 'undefined') {
      for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }
      console.log("[".concat(currentTime, "][").concat(this.name, "][").concat(level, "] ").concat(message), ...args);
    }
  }

  /**
   * Logs a debug message.
   * @param {string} message - The message to log.
   * @param  {...any[]} args - Additional arguments to log.
   */
  debug(message) {
    if (!this.debugMode) return;
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }
    this.log(LogLevel.DEBUG, message, ...args);
  }

  /**
   * Logs an info message.
   * @param {string} message - The message to log.
   * @param  {...any[]} args - Additional arguments to log.
   */
  info(message) {
    for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      args[_key3 - 1] = arguments[_key3];
    }
    this.log(LogLevel.INFO, message, ...args);
  }

  /**
   * Logs a warn message.
   * @param {string} message - The message to log.
   * @param  {...any[]} args - Additional arguments to log.
   */
  warn(message) {
    for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
      args[_key4 - 1] = arguments[_key4];
    }
    this.log(LogLevel.WARN, message, ...args);
  }

  /**
   * Logs an error message.
   * @param {string} message - The message to log.
   * @param  {...any[]} args - Additional arguments to log.
   */
  error(message) {
    for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
      args[_key5 - 1] = arguments[_key5];
    }
    this.log(LogLevel.ERROR, message, ...args);
  }
}
exports.Logger = Logger;